import React from "react";
import "./StockDetail.scss";
import {
	MDBBox,
	MDBIcon, MDBModal, MDBModalBody,
	MDBTypography
} from "mdbreact";

import KeyInfo from "../../component/KeyInfo/KeyInfo";
import SubPageHeader from "../../component/SubPageHeader/SubPageHeader";
import StockChart from "../../component/StockChart";
import ThreeDPieChart from "../../component/ThreeDPieChart/ThreeDPieChart";
import BottomModal from "../../component/BottomModal/BottomModal";

import cogoToast from "cogo-toast";
import CreateOrderMutation from "../../mutations/CreateOrderMutation";
import StockDetailByIdQuery from "../../queries/StockDetailByIdQuery";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import AllNewsQuery from "../../queries/AllNewsQuery";
import NewsList from "../../component/NewsList/NewsList";
import {compose} from "redux";
import {connect} from "react-redux";
import {withRouter, Link} from "react-router-dom";
import SimilarStocks from "../../component/SimilarStocks/SimilarStocks";
import Loading from "../../component/Loading";
import {assetUrl, loss_color, profit_color} from "../../serviceApi";
import SectionHeader from "../../component/SectionHeader/SectionHeader";
import {Fade, Zoom, Slide} from 'react-reveal'
import OrderConfirmation from "../../component/OrderConfirmation/OrderConfirmation";
import PinVerification from "../../component/PinVerification/PinVerification";
import StockPerformanceAnalysisQuery from "../../queries/StockPerformanceAnalysisQuery";
import {NonEmptyArray, numberFormat} from "../../util";

import PreBookStock from "../../component/UpcommingStocks/PreBookStock";

import DetailPageModalFooter from "../../component/DetailPageModalFooter/DetailPageModalFooter";
import {AddFilter, setLoginStep} from "../../Actions";

import ReactTooltip from 'react-tooltip';
import Lottie from "react-lottie";
import {animationData} from "../../component/Loading/loadingAnimationData";
import moment from "moment";
import AddMoney from "../UserWallet/AddMoney";
import CheckOrderStatusQuery from "../../queries/CheckOrderStatusQuery";
import StockGraph from "../../component/StockGraph/StockGraph";
import OrderPendingModal from "../../component/OrderPendingModal/OrderPendingModal";
import StockOwnedCountQuery from "../../queries/StockOwnedCountQuery";
import StockHistoryDetailsQuery from "../../queries/StockHistoryDetailsQuery";
import Skeleton from "react-loading-skeleton";
import Login from "../Login/Login";

const PartySymbol = assetUrl + "images/party-symbol.svg";
const dot_icon = assetUrl + "images/Information-icon.svg";
const UpArrow = assetUrl + "images/up-arrow.svg";
const vector_arrow_up = assetUrl + "tmp-images/vector_arrow_up.svg";
const vector_arrow_down = assetUrl + 'images/landing-portfolio-loss.png';
const AssetIcon = assetUrl + "images/assets-icon2.png";
const ZigZagIcon = assetUrl + "images/zig-zag-icon.svg";
const button_arrow_down = assetUrl + "tmp-images/button_arrow_down.svg";
const button_arrow_up = assetUrl + "tmp-images/button_arrow_up.svg";
const GraphIcon = assetUrl + "images/graph-icon.svg";
const WalletIcon = assetUrl + "images/buy-share-wallet-icon.png";
const ArrowRightIcon = assetUrl + "images/arrow-right-sm.svg";
const ProfileIcon = assetUrl + "images/profile-icon.svg";
const SimilarTocksIcon = assetUrl + "images/similar-stocks.svg";
const upcommingImage = assetUrl + 'images/profile-icon.svg'
const info = assetUrl + 'images/icon_info.svg'
const NewsIcon = assetUrl + "images/news-icon.svg";
const StockClock = assetUrl + "images/upcomming_profilePic_timer.png";
const AngleRight = assetUrl + "images/Icon_Forward.svg";
const downArrow = assetUrl + 'images/arrow-red-down-with-bg.svg'

const initial_key_info = [
	{
		title: "Age",
		value: ""
	},
	{
		title: "Current Position",
		value: ""
	},
	{
		title: "Education",
		value: ""
	},

	{
		title: "Alma mater",
		value: ""
	}

];

const initial_analyst_rating = [
	{
		title: "Buy",
		percent: 0,
		color: "#0AC09E"
	},
	{
		title: "Sell",
		percent: 0,
		color: "#FF5C5C"
	},
	{
		title: "Hold",
		percent: 0,
		color: "#F1C144"
	}
];

class StockDetail extends React.Component {
	state = {
		graph_filter: "1day",
		key_info: initial_key_info,
		open_modal: false,
		selected_action: "",
		full_height_modal: false,
		orderMode: "Market_Order",
		quantity: 1,
		pin: "",
		stockId: "",
		tags_list: [],
		analyst_rating: initial_analyst_rating,
		political_career: [],
		news_list: [],
		stock_detail: {},
		completed_action: "",
		order_failed: false,
		// stock_data: {},
		politician_assets: {},
		// user_performance_analysis: [],
		lastOrderId: "",
		lastOrderStatus: "",
		similarStocks: [],
		limit_order_price: 0,
		user_performance: [],
		stock_detail_data: {},
		scroll: false,
		xAxis: [],
		yAxis: [],
		loadingArray: ["loading"],
		graph_loading: false,
		stockProfile_circle: false,
		similare_stockId: "",
		stockOwnedCount: 0,
		stockHistoryDetails: {},
		login_modal:false

	}

	componentWillMount() {
		// this.setState({
		// political_career:politicalCareer,
		// news_list: newsList,
		// stock_data: SingleStockData,
		// similarStocks: SingleStockData.relatedPoliticians.edges,
		// user_performance_analysis:userPerformanceAnalysis,
		// politician_assets: SingleStockData.politicianassets.edges.length >0 ? SingleStockData.politicianassets.edges[0].node:{}
		// });
	}

	componentDidMount() {
		if (this.state.loadingArray.length === 1
			&& !this.state.stockProfile_circle
		) {
			setTimeout(() => {

				this.setState({
					stockProfile_circle: true
				})
			}, 2000)
		}
		this.setState({
			stockId: this.props.match.params.id
		}, () => {
			this.getStockPerformance();
			this.getStockDetail();
			this.getStockNews();
			if(this.props.logged_in){
				this.getStockOwnedCount();
			}
			this.getStockHistoryDetails();
		});
	}


	//

	// componentWillReceiveProps(nextProps, nextContext) {
	//
	// 	if(this.props.match.params.id !== nextProps.match.params.id){
	// 		this.setState({
	// 			stockId: nextProps.match.params.id
	// 		},()=>{
	// 			this.getStockDetail();
	// 		})
	//
	// 	}
	//
	// }

	handleSimilareStockRedirection = (args) => {
		// similare_stockId is for reference that the user has clicked to view related stocks
		this.setState({
			similare_stockId: args
		}, () => {
			// callback to update the page's data
			this.getStockPerformance();
			this.getStockDetail();
			this.getStockNews();
			this.getStockOwnedCount();
			this.getStockHistoryDetails();

		})
	}

	getStockOwnedCount = () => {
		let variables = {
			stockId: this.props.match.params.id
		}
		this.updateLoading(true);
		fetchQuery(environment, StockOwnedCountQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);

				if (response.stockOwnedCount !== 0 && response.stockOwnedCount !== null && Object.keys(response.stockOwnedCount).length > 0) {

					let temp_stockOwnedCount = Object.values(response.stockOwnedCount)[0] ? Object.values(response.stockOwnedCount)[0] : 0
					this.setState({
						stockOwnedCount: temp_stockOwnedCount
						// stock_list:response.allPoliticians.edges.length>0 ?response.allPoliticians.edges:[]
					})
					// console.log(response.allPoliticians.edges)
				} else {
					this.setState({
						stockOwnedCount: 0

					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stockOwnedCount: 0
				})
			});
	}

	getStockHistoryDetails = () => {
		let variables = {
			stockId: this.props.match.params.id
		}
		this.updateLoading(true);
		fetchQuery(environment, StockHistoryDetailsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);

				if (response.stockHistoryDetails !== null && Object.keys(response.stockHistoryDetails).length > 0) {

					this.setState({
						stockHistoryDetails: response.stockHistoryDetails[0]
						// stock_list:response.allPoliticians.edges.length>0 ?response.allPoliticians.edges:[]
					})
					// console.log(response.stockHistoryDetails.price_diff)
				} else {
					this.setState({
						stockHistoryDetails: {}

					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stockHistoryDetails: {}
				})
			});
	}

	getStockDetail = () => {
		//	for related stock page redirection the "id" value has changed
		let variables = {
			id: this.props.match.params.id
		}
		this.updateLoading(true);
		let scope = this;
		fetchQuery(environment, StockDetailByIdQuery, variables)
			.toPromise()
			.then(response => {

				if (NonEmptyArray(response.allPoliticians) && response.allPoliticians.edges[0]) {

					let nodeData = response.allPoliticians.edges.length > 0 ? ((response.allPoliticians.edges).slice(0, 1).shift()).node : null;

					let tags_list = nodeData.tags;
					let temp_key_info = scope.state.key_info.slice();
					// temp_key_info[0].value = getFormattedDate(nodeData.dob);
					// temp_key_info[1].value = nodeData.birthplace;
					temp_key_info[0].value = nodeData.age;
					temp_key_info[1].value = nodeData.currentPosition;
					temp_key_info[2].value = nodeData.education;
					temp_key_info[3].value = nodeData.almaMater;

					let analyst_rating = scope.state.analyst_rating.slice();
					analyst_rating[0].percent = nodeData.buy;
					analyst_rating[1].percent = nodeData.sell;
					analyst_rating[2].percent = nodeData.hold;
					let political_career = nodeData.politiciantimelines.edges;

					this.updateLoading(false);
					this.setState({

						stock_detail: response.allPoliticians.edges[0].node,
						tags_list: tags_list,
						key_info: temp_key_info,
						analyst_rating: analyst_rating,
						political_career: political_career,

						politician_assets: nodeData.politicianassets.edges.length > 0 && response.allPoliticians.edges[0].node.politicianassets ? nodeData.politicianassets.edges[0].node : {},
						similarStocks: nodeData.relatedPoliticians.edges,

					});
					// setTimeout(()=>{

					// 	this.setState({
					// 		stock_detail_data: this.state.stock_detail,
					// 	})
					// },2000)

				} else {
					scope.setState({
						stock_detail: {},
						tags_list: [],
						key_info: [],
						analyst_rating: [],
						political_career: [],
						// stock_detail_data: {},
						politician_assets: {}
					});
				}
			}, err => {
				console.log(err);
				scope.setState({
					stock_detail: {},
					tags_list: [],
					key_info: [],
					analyst_rating: [],
					political_career: [],
					// stock_detail_data: {},
					politician_assets: {}
				});
			});
	}

	getStockNews = () => {
		let variables = {
			politician: this.state.stockId
		}
		this.updateLoading(true);
		fetchQuery(environment, AllNewsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (NonEmptyArray(response.allNews)) {
					this.setState({
						news_list: response.allNews.edges
					})
				} else {
					this.setState({
						news_list: []
					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					news_list: []
				})
			});
	}

	getStockPerformance = () => {

		let week = 0;
		let day = 0;
		let month = 0;
		if (this.state.graph_filter === "1week") {
			week = 1;
		} else if (this.state.graph_filter === "2week") {
			week = 2;
		} else if (this.state.graph_filter === "1day") {
			day = 1;
		} else if (this.state.graph_filter === "1month") {
			month = 1;
		} else if (this.state.graph_filter === "all") {
			month = 1;
			day = 1;
			week = 1;
		}
		let variables = {
			stockId: this.state.stockId,
			weeks: week,
			days: day,
			month: month,
			all: this.state.graph_filter === "all"
		}
		this.setState({
			graph_loading: true
		})
		// this .updateLoading(true);
		fetchQuery(environment, StockPerformanceAnalysisQuery, variables)
			.toPromise()
			.then(response => {
				this.setState({
					graph_loading: false
				})
				// this.updateLoading(false);
				if (response.stockPerformanceAnalysis !== null && response.stockPerformanceAnalysis.length > 0) {
					let xaxis = [];
					let yaxis = [];
					let graphData = response.stockPerformanceAnalysis ? response.stockPerformanceAnalysis : [];
					if (graphData.length === 1) {
						var nowHour = new Date(graphData[0].created).getHours();
						var startDate = new Date(graphData[0].created);
						startDate.setDate(startDate.getDate() - 1);
						for (var i = 0; i < nowHour; i++) {
							let date = new Date(new Date(graphData[0].created).getTime() - (1000 * 60 * (60 * i)));
							if (date.getDate() > startDate.getDate()) {
								xaxis.push(date);
								yaxis.push(graphData[0].updatedPrice);
							}
						}
					} else {
						for (let i = 0; i < response.stockPerformanceAnalysis.length; i++) {
							if (response.stockPerformanceAnalysis[i]) {
								yaxis[i] = graphData[i].updatedPrice;
								xaxis[i] = graphData[i].created;
								// console.log(new Date(graphData[i].created));
							}
						}
					}

					this.setState({
						xAxis: xaxis,
						yAxis: yaxis
					})
				} else {
					this.setState({
						xAxis: [],
						yAxis: []
					})
				}
			}, err => {
				// this.updateLoading(false);
				console.log(err);
				this.setState({
					xAxis: [],
					yAxis: [],
					graph_loading: false
				})
			});
	}

	filterGraph = (data) => {
		this.setState({
			graph_filter: data,
			xAxis: [],
			yAxis: []
		}, () => {
			this.getStockPerformance();
		});
	}

	openModal = (action) => {
		if (action === "sell") {
			// stockOwnedCount changes
			if (this.state.stockOwnedCount === 0) {
				cogoToast.error("You don't have this Stock", {position: 'top-center'});
			} else {
				this.setState({
					open_modal: true,
					selected_action: action
				});
			}
		} else {
			this.setState({
				open_modal: true,
				selected_action: action
			});
		}

	}

	openFullHeightModal = (action) => {
		this.setState({
			full_height_modal: true,
		});
	}

	closeFullHeightModal = () => {
		this.setState({
			full_height_modal: false,
			quantity: 1,
			pin: "",
			limit_order_price: 0
		});
	}

	closeModal = () => {

		if ((this.state.selected_action === "waiting" && this.state.lastOrderStatus !== "")
			|| (this.state.selected_action === "" && this.state.lastOrderStatus !== "")
			|| (this.state.selected_action === "waiting" && this.state.orderMode === "Limit_Order")) {
			// pending orders and pending order modal(executed stated )
			window.location.reload()
		}

		this.setState({
			open_modal: false,
			quantity: 1,
			pin: "",
			limit_order_price: 0,
			selected_action: ""
		});

	}

	handleRadioInputs = (data) => {
		this.setState({
			orderMode: data
		});
	}

	handleQtyChange = (e, feild) => {
		this.setState({
			[feild]: e.target.value
		});
	}

	handleSellOrBuySubmit = () => {
		// TODO
		if (this.state.selected_action === "buy") {

			if (this.state.quantity === "" || this.state.quantity < 0) {
				cogoToast.error("Please fill valid quantity", {position: 'top-center'});
			} else if ((this.state.quantity * this.state.stock_detail.price > this.props.wallet_data.balance) && this.state.quantity * this.state.limit_order_price > this.props.wallet_data.balance) {

				this.setState({
					selected_action: ""
				})
			} else if (((this.state.quantity * this.state.stock_detail.price > this.props.wallet_data.balance || this.state.quantity * this.state.limit_order_price > this.props.wallet_data.balance)) && this.state.orderMode === "Market_Order") {

				this.setState({
					selected_action: ""
				})
			} else {
				// debugger
				this.openFullHeightModal();
			}
		}
		if (this.state.selected_action === "sell") {

			if (this.state.quantity === "" || this.state.quantity < 0) {
				// debugger
				cogoToast.error("Please fill valid quantity", {position: 'top-center'});
				// stockOwnedCount changes
			} else if (this.state.quantity > this.state.stockOwnedCount) {
				cogoToast.error("You have exceeded stock quantity", {position: 'top-center'});
			} else {
				// debugger
				this.openFullHeightModal();
			}
		}

	}

	handlePinInputChange = (e) => {
		this.setState({
			pin: (e.target.validity.valid) ? e.target.value : this.state.pin
		})
	}

	reloader = () => {
		// setTimeout(() => {
		// 	this.props.history.push("/portfolio")
		// }, 2500)

	}

	createOrder = () => {
		// debugger
		let variable = {
			stockId: this.state.stockId,
			quantity: this.state.quantity,
			orderMode: this.state.orderMode,
			orderType: this.state.selected_action === "buy" ? "Buy" : "Sell",
			userPin: this.state.pin
		}
		if (this.state.orderMode === "Limit_Order") {
			variable["limitOrderPrice"] = this.state.limit_order_price;
		}
		let scope = this;
		if (this.state.pin === "" || this.state.pin < 4) {
			cogoToast.error("Please fill valid pin", {position: 'top-center'});
		} else {

			this.updateLoading(true);

			CreateOrderMutation(variable, function (response) {
				// debugger
				scope.updateLoading(false);
				if (response.createOrder.order.id) {
					scope.setState({
						completed_action: response.createOrder.order.orderType,
						// waiting screen change
						lastOrderId: response.createOrder.order.id,
						selected_action: "waiting",
						// quantity:0,
						pin: "",
						order_failed: false,
						full_height_modal: false,
					})
					scope.reloader()
				}
			}, function (err) {
				scope.updateLoading(false);
				cogoToast.error(err, {position: 'top-center'});

			});
		}
	}

	checkStatus = () => {
		if (this.state.selected_action === "waiting" && this.state.selected_action !== "") {
			if (this.state.lastOrderStatus === "EXECUTED" || this.state.lastOrderStatus === "executed") {
				this.setState({
					completed_action: this.state.completed_action,
					selected_action: "",

				})
			} else {
				console.log("checked")
				let variable = {
					id: this.state.lastOrderId
				}
				fetchQuery(environment, CheckOrderStatusQuery, variable)
					.toPromise()
					.then(response => {
						if (NonEmptyArray(response.allOrders)) {
							this.setState({
								lastOrderStatus: response.allOrders.edges[0].node.orderStatus
							})
						} else {
							this.setState({
								lastOrderStatus: ""
							})
						}
					}, err => {
						console.log(err)
						this.setState({
							lastOrderStatus: ""
						})
					})
			}

		}
	}

	updateLoading = (action) => {
		let tmp_loading_array = this.state.loadingArray;
		if (action) {
			tmp_loading_array.push("loading");
		} else {
			tmp_loading_array.pop();
		}
		this.setState({
			loadingArray: tmp_loading_array
		})
	}

	filterStock = () => {
		let filter_obj = {
			party: this.state.stock_detail.party
		};
		this.props.applyFilter(filter_obj);
		this.props.history.push("/all-stocks");
	}
	// scrollChecker = () => {
	//
	// 	if (window.scrollY > 20) {
	// 		this.setState({scroll: true})
	// 	} else {
	// 		this.setState({...this.state, scroll: false})
	// 	}
	// }

	openLoginModal = () => {
		this.setState({
			login_modal:true
		});
	}
	closeLoginModal = () => {
		this.setState({
			login_modal:false
		});
	}
	completeLogin = () => {
		this.closeLoginModal();
		// this.getStockOwnedCount();
		window.location.reload();
	}
	checkUserLoggedIn = (action) => {
		if(this.props.logged_in === false){
			this.openLoginModal();
		} else {
			this.openModal(action);
		}
	}

	render() {
		let modal_title = "";

		if (this.state.selected_action === "sell") {
			modal_title = "Sell Shares";
		} else if (this.state.selected_action === "buy") {
			modal_title = "Buy Shares";
		}

		if (this.state.selected_action === "") {
			modal_title = "";
		}
		if (this.state.stock_detail.upcoming === true) {
			modal_title = "Subscribe";
		}

		// // profile circle animation
		// const defaultOptions = {
		// 	loop: true,
		// 	autoplay: true,
		// 	animationData: ProfileCircleAnimation,
		// 	rendererSettings: {
		// 		preserveAspectRatio: 'xMidYMid slice'
		// 	}
		//
		// };
		// console.log(this.state.stock_detail.party)

		return (
			// <Loading loading={this.state.loadingArray.length > 1}>
			// 	{this.state.user_performance.length > 0 &&
			<MDBBox className="stock-detail-component">
				{/*
						hasPreviousStockPage -  checking if the user has clicked on related stocks
						origin_stock_id - the page which has related stocks
						setoriginStockId -  to change the state of "similare_stockId"
					*/}
				<SubPageHeader title="Details" show_action={true}
				               hasPreviousStockPage={this.state.similare_stockId !== "" && this.state.similare_stockId !== this.state.stockId || this.state.similare_stockId === "clear"}
				               origin_stock_id={this.state.stockId}
				               setOriginStockId={(args) => {
					               this.handleSimilareStockRedirection(args)
				               }}/>
				<div className={"main-section"}>
					<div className="user-detail-section d-flex justify-content-between">
						<div className=" d-flex w-100">
							{
								Object.keys(this.state.stock_detail).length < 1 ?
									<Skeleton circle={true} height={"80px"} width={"80px"}/> :
									<div className={"image-section"}>
										<div className="user-profile-section ">
											<img
												src={this.state.stock_detail.politicianImage ? this.state.stock_detail.politicianImage : ProfileIcon}
												alt="userImage"
												className={this.state.stockProfile_circle ? "stock-profile circle spin-active" : "stock-profile circle spin"}
												style={{width: "72px", height: "72px", objectFit: "contain"}}/>
											{/*<Lottie options={defaultOptions} width={"100%"} height={"239px"}/>*/}
										</div>
										{
											this.state.stock_detail.upcoming === true &&
											<img src={StockClock} alt={"StockClock"} className={"clock-image"}/>
										}
									</div>
							}
							<div className="stock-profile-info w-100">
								{Object.keys(this.state.stock_detail).length < 1 ? <Skeleton count={3} width={"70%"}/> :
									<>
										{/*<Fade bottom delay={1000}>*/}
										<p className="user-name">{this.state.stock_detail.name}</p>
										{/*</Fade>*/}
										{/*<Fade bottom delay={1100}>*/}
										<p className="user-role">{this.state.stock_detail.currentPosition}</p>
										{/*</Fade>*/}
										{/*<Fade bottom delay={1200}>*/}
										{/*<div className={"d-flex justify-content-between align-items-center"}>*/}
										<p className="user_adress">
											{
												this.state.stock_detail.region ? this.state.stock_detail.region.regionName : ""
											}
										</p>
										<Link
											to={`/party-detail/${this.state.stock_detail.party ? this.state.stock_detail.party.id : ""}`}>
											<div className="d-flex align-items-center party-logo-name">
												{/*<Zoom delay={1300}>*/}
												<img
													src={this.state.stock_detail.party && this.state.stock_detail.party.partyImage ? this.state.stock_detail.party.partyImage : PartySymbol}
													alt="PartySymbol"
													style={{
														width: "32px",
														height: "32px",
														objectFit: "contain"
													}}/>
												{/*</Zoom>*/}
												{/*<Zoom delay={1350}>*/}
												<p className="party_name">
													{this.state.stock_detail.party ? this.state.stock_detail.party.partyName : ""}
												</p>
												{/*</Zoom>*/}
											</div>
										</Link>
										{/*</div>*/}
										{/*</Fade>*/}
									</>
								}

							</div>
						</div>
					</div>

					{
						Object.keys(this.state.stock_detail).length < 1 ?
							<>
								<br/>
								<Skeleton count={1}/>
							</>
							:
							<>
								{this.state.stock_detail.upcoming === true ?
									<div className={"upcomming-section"}>
										<div className={"upcomming-stocks-main"}>
											<p className={'stock-percentage'}><span style={{
												fontWeight: 600,
												marginRight: "4px",
												marginBottom: "8px"
											}}>{this.state.stock_detail.upcomingStocksSubscribed}/{this.state.stock_detail.upcomingStocks}</span> Shares
												Left
											</p>
											<div className={"progress-bg"}>
												<div className="progress">
													<div className="progress-bar" role="progressbar"
													     style={{width: `${100 - (this.state.stock_detail.upcomingStocksPercentage)}%`}}
													     aria-valuenow={100 - (this.state.stock_detail.upcomingStocksPercentage)}
													     aria-valuemin="0" aria-valuemax="100"/>
												</div>
											</div>
											<div className={'d-flex justify-content-between'}
											     style={{marginTop: "22px"}}>
												{/*stockOwnedCount changes*/}
												{this.state.stockOwnedCount > 0 &&
												<div className={'d-flex align-items-center'}>
													<img src={GraphIcon} alt={"alt"} className={"upcomming-image"}/>
													<p className={'stock-booked'}><span
														style={{fontWeight: 700}}>{this.state.stockOwnedCount}</span> {this.state.stockOwnedCount > 1 ? " Shares " : " Share "}
														subscribed</p>
													<img src={info} alt={"alt"} data-tip
													     data-for={'upcoming-subscribed'} className={""}
													     width={"16px"}
													     height={"16px"}/>
													<ReactTooltip id='upcoming-subscribed' type='light'
													              effect={"solid"}
													              place={"bottom"}>
														<span
															className={"tooltip-light"}>You can subscribe to shares<br/> of new politicians at face<br/> value before they become<br/> tradable in the market.</span>
													</ReactTooltip>

												</div>}

												{/*<div className={'d-flex align-items-end'}>*/}
												{/*	<p className={'view-order'}>View Order</p>*/}
												{/*	<MDBIcon icon="angle-right" style={{color: "#AB8EF5"}}/>*/}
												{/*</div>*/}
											</div>
										</div>
										<hr className={"stock-divider"}/>

										<div className={"stock-pre-booking-section"}>
											<div className={"d-flex align-items-end mb-2"}>
												<p className={"pre-booking-text "}>Current Subscribed Price</p>
												<img src={info} data-tip
												     data-for={'upcoming-current-subscribe'} alt={"alt"}
												     className={""}/>
												<ReactTooltip id='upcoming-current-subscribe' type='light'
												              effect={"solid"}
												              place={"bottom"}>
														<span
															className={"tooltip-light"}>You can subscribe to shares<br/> of new politicians at face<br/> value before they become<br/> tradable in the market.</span>
												</ReactTooltip>

											</div>
											<p className={"pre-booking-price"}>{numberFormat(this.state.stock_detail.price)}</p>
											<div className={"pre-booking-volume-card"}>
												<div className={"d-flex justify-content-between"}>
													<p className={"title"}>Volume</p>
													<p className={"value"}>
														{
															this.state.stock_detail.lockedShares ? this.state.stock_detail.lockedShares : 0
														}
													</p>
												</div>
												<div style={{height: "8px"}}/>
												<div className={"d-flex justify-content-between"}>
													<p className={"title"}>Market Cap</p>
													<p className={"value"}>
														{this.state.stock_detail.marketCap ? numberFormat(this.state.stock_detail.marketCap) : 0}
													</p>
												</div>
											</div>

										</div>
									</div>
									:
									<>
										{this.state.tags_list.length > 0 &&
										<div className="badge-section">
											<MDBBox>
												<MDBBox className="d-flex">
													{
														this.state.tags_list.map((item, index) => {
															return (
																<div key={index}>
																	{/*<Zoom delay={1400} cascade>*/}
																	<MDBBox
																		className="tmp_badge d-flex align-items-center"
																		key={index}>
																		<p className="tag-name">{item}</p>
																	</MDBBox>
																	{/*</Zoom>*/}
																</div>
															);
														})
													}
												</MDBBox>
											</MDBBox>
										</div>
										}
										<hr className={'stock-divider'}
										    style={this.state.tags_list.length > 0 ? {margin: 0} : {marginTop: "24px"}}/>
									</>

								}
							</>

					}

					<>
						{
							// (this.state.stock_detail.upcoming === false && this.state.stock_detail) &&
							<>
								{/*<Fade bottom cascade delay={1500}>*/}
								{/*{this.state.stock_detail.upcoming === false &&*/}
								<div
									className={this.state.stock_detail.upcoming ? "stock-graph-section set-component-hidden" : "stock-graph-section"}>
									{/*stockOwnedCount changes*/}
									{
										this.state.stockOwnedCount !== 0 && this.state.stock_detail.upcoming === false &&
										<MDBBox className="d-flex align-items-center stock-own-section"
											// style={this.state.stock_detail.stockOwnedCount !== 0 ? {visibility: "visible"} : {visibility: "hidden"}}
										>
											<img src={GraphIcon} alt="GraphIcon"
											     className="img-fluid  graph-icon"/>
											<div className={"d-flex stock-own-content-content"}>
									<span
										className={"stock-own-count"}>{this.state.stockOwnedCount}</span>
												<MDBTypography tag="p"
												               className="stock-own-text">{this.state.stockOwnedCount > 1 ? "Shares " : "Share "}
													owned</MDBTypography>
											</div>
										</MDBBox>
									}

									<div className="stock-detail-current" style={{marginTop: "16px"}}>

										{this.state.stock_detail.upcoming === false &&
										<p className="current-price-title">Current Price</p>}

										<div className=" d-flex align-items-center justify-content-between">
											<div>
												{this.state.stock_detail.upcoming === false &&
												<p className="stock-price">{numberFormat(this.state.stock_detail.price)}
													{/*<span className="light_text">05</span>*/}
												</p>}
												{(Object.keys(this.state.stockHistoryDetails).length < 1) ?
													<>
														<Skeleton width={"100px"} style={{marginBottom:"12px"}}/>
														<br/>
														<Skeleton width={"100px"}/>
													</>
													:
													this.state.stock_detail.upcoming === false &&
													<div className=" d-flex align-items-center ">
														{
															this.state.stockHistoryDetails.price_diff >= 0 ?
																<p className="stock_value"
																   style={{color: profit_color}}>
																	+{this.state.stockHistoryDetails.price_diff_percentage}%
																	({numberFormat(this.state.stockHistoryDetails.price_diff && this.state.stockHistoryDetails.price_diff.toFixed(2))})
																</p> :
																<p className="stock_value"
																   style={{color: loss_color}}>
																	{this.state.stockHistoryDetails.price_diff_percentage}%
																	({numberFormat(this.state.stockHistoryDetails.price_diff && this.state.stockHistoryDetails.price_diff.toFixed(2))})
																</p>

														}

														<img alt={"alt"} src={dot_icon} className="dot_icon"
														     data-tip
														     data-for={'stock-info'}/>
														<ReactTooltip id='stock-info' type='light'
														              effect={"solid"}
														              place={"right"}>
															<span className={"tooltip-current-price"}>This is the price change in<br/> the last 24 hours</span>
														</ReactTooltip>
													</div>
												}
											</div>

											{
												Object.keys(this.state.stockHistoryDetails).length < 1 ?
													<Skeleton width={"60px"} height={"60px"}/> :
													this.state.stock_detail.upcoming === false &&
													<img alt={"alt"}
													     src={this.state.stockHistoryDetails.price_diff >= 0 ? UpArrow : downArrow}/>
											}
										</div>
									</div>

									{/*<AreaChartComponent />*/}

									{/*{this.state.stock_detail.upcoming === false &&*/}
									<MDBBox style={{background: "#f5f3fb47", borderRadius: "8px"}}
									        className={this.state.stock_detail.upcoming ? "graph-wrapper set-component-hidden" : "graph-wrapper "}>
										{
											this.state.graph_loading ?
												<Skeleton height={"200px"} width={"100%"}/>
												:
												this.state.stock_detail.upcoming === false &&
												<StockGraph curve={"smooth"}
												            color={"#AB8EF5"}
												            xaxis={this.state.xAxis}
												            yaxis={this.state.yAxis}
												            graph_filter={this.state.graph_filter}
												            sparkline={false}
												            graph_loading={this.state.graph_loading}
												/>
										}

										{this.state.stock_detail.upcoming === false && <MDBBox
											className="d-flex align-items-center justify-content-around graph-filter-container ">
											<MDBBox
												className={this.state.graph_filter === "1day" ? "graph-filter-text active" : "graph-filter-text"}
												onClick={() => this.filterGraph("1day")}
											>
												1 Day
											</MDBBox>
											<MDBBox
												className={this.state.graph_filter === "1week" ? "graph-filter-text active" : "graph-filter-text"}
												onClick={() => this.filterGraph("1week")}
											>
												1 Week
											</MDBBox>
											<MDBBox
												className={this.state.graph_filter === "2week" ? "graph-filter-text active" : "graph-filter-text"}
												onClick={() => this.filterGraph("2week")}
											>
												2 Weeks
											</MDBBox>
											<MDBBox
												className={this.state.graph_filter === "1month" ? "graph-filter-text active" : "graph-filter-text"}
												onClick={() => this.filterGraph("1month")}
											>
												1 Month
											</MDBBox>
											<MDBBox
												className={this.state.graph_filter === "all" ? "graph-filter-text active" : "graph-filter-text"}
												onClick={() => this.filterGraph("all")}
											>
												All
											</MDBBox>
										</MDBBox>}
									</MDBBox>
									{/*}*/}

								</div>
								{/*}*/}
								{/*</Fade>*/}
								{/*<Fade bottom cascade delay={1500}>*/}
								{/*{this.state.stock_detail.upcoming === false && */}
								<div className={this.state.stock_detail.upcoming?"set-component-hidden stock-detail-footer":"stock-detail-footer"}>
									{
										Object.keys(this.state.stock_detail).length < 1 ? <Skeleton height={"72px"} width={'100'} style={{marginBottom:"16px"}}/> :
											<MDBBox className="stock-detail-footer-container">
												<MDBBox className="">
													<MDBBox className="d-flex justify-content-between">
														<MDBBox className="volume">
															<p className="volume_text">Total Shares</p>
															<p className="volume_number">
																{
																	this.state.stock_detail.totalShare ? this.state.stock_detail.totalShare : 0
																}
															</p>
														</MDBBox>
														{/*<MDBBox className="volume">*/}
														{/*	<p className="volume_text">Avg Price</p>*/}
														{/*	<p className="volume_number my-1">*/}
														{/*		{this.state.stock_detail.price ? numberFormat(this.state.stock_detail.price) : 0}*/}
														{/*	</p>*/}
														{/*</MDBBox>*/}
														<MDBBox className="volume">
															<p className="volume_text">Market Cap</p>
															<p className="volume_number">
																{this.state.stock_detail.marketCap ? numberFormat(this.state.stock_detail.marketCap) : 0}
															</p>
														</MDBBox>
														<MDBBox className="volume">
															<p className="volume_text">Rank</p>
															<div className={'d-flex align-items-center'}>
																<p className="volume_number"
																   style={{marginRight: "6px"}}>
																	{this.state.stock_detail.rank ? (this.state.stock_detail.rank) : 0}
																</p>
																{
																	this.state.stockHistoryDetails.price_diff >= 0 ?
																		<MDBIcon icon="caret-up"
																		         style={{color: profit_color}}
																		         className={"stock-arrow"}/> :
																		<MDBIcon icon="caret-down"
																		         style={{color: loss_color}}
																		         className={"stock-arrow"}/>
																}
															</div>

														</MDBBox>
													</MDBBox>
												</MDBBox>
											</MDBBox>
									}

								</div>
								{/*}*/}
								{/*</Fade>*/}
								{/*<Fade bottom cascade delay={100}>*/}
								{/*{this.state.stock_detail.upcoming === false &&*/}
								<div className={this.state.stock_detail.upcoming?"stock-detail-section set-component-hidden":"stock-detail-section"}>
									{
										Object.keys(this.state.stock_detail).length < 1 ?
											<Skeleton height={"208px"} width={'100'}/> :
											<MDBBox className="stock-detail-container">
												<MDBBox className="">
													{/*<p className="current-stock-title">Today's High/Low</p>*/}
													{/*<Fade bottom cascade delay={500}>*/}
													<MDBBox
														className="current-stock-value-section d-flex justify-content-between pt-0">
														<MDBBox className="w-50">
															<p className="stock-value-in-text  ">1D Low</p>
															<MDBBox className="d-flex align-items-center">
																<p className="stock-value-in-number-green"
																	// style={{color: this.state.stock_data.stockLowValue > 0 ? profit_color : loss_color}}
																>
																	₹{this.state.stockHistoryDetails.today_low_value !== null ? this.state.stockHistoryDetails.today_low_value : 0}
																</p>
																{
																	this.state.stockHistoryDetails.today_low_value >= 0 ?
																		<MDBIcon icon="caret-up"
																		         style={{color: profit_color}}
																		         className={"stock-arrow"}/> :
																		<MDBIcon icon="caret-down"
																		         style={{color: loss_color}}
																		         className={"stock-arrow"}/>
																}
															</MDBBox>
														</MDBBox>
														<MDBBox className="w-50">
															<p className="stock-value-in-text  ">1D High</p>
															<MDBBox className="d-flex align-items-center">
																<p className="stock-value-in-number-red  "
																	// style={{color: this.state.stock_data.stockHighValue > 0 ? profit_color : loss_color}}
																>
																	₹{this.state.stockHistoryDetails.today_high_value !== null ? this.state.stockHistoryDetails.today_high_value : 0}
																</p>
																{
																	this.state.stockHistoryDetails.today_high_value >= 0 ?
																		<MDBIcon icon="caret-up"
																		         style={{color: profit_color}}
																		         className={"stock-arrow"}
																		/> :
																		<MDBIcon icon="caret-down"
																		         style={{color: loss_color}}
																		         className={"stock-arrow"}
																		/>
																}
															</MDBBox>
														</MDBBox>
													</MDBBox>
													{/*</Fade>*/}
													<div style={{height: "16px"}}/>
													{/*<p className="current-stock-title">1 Year High/Low</p>*/}
													{/*<Fade bottom cascade delay={600}>*/}
													<div
														className="d-flex justify-content-between current-stock-value-section py-0"
														style={{borderBottom: "none"}}>
														<MDBBox className="w-50">
															<p className="stock-value-in-text">1Y Low</p>
															<MDBBox className="d-flex align-items-center">
																<p className="stock-value-in-number-green"
																	// style={{color: this.state.stock_data.stockLowValueLongTerm > 0 ? profit_color : loss_color}}
																>
																	₹{this.state.stockHistoryDetails.long_term_low_value !== null ? this.state.stockHistoryDetails.long_term_low_value : 0}
																</p>
																{
																	this.state.stockHistoryDetails.long_term_low_value >= 0 ?
																		<MDBIcon icon="caret-up"
																		         style={{color: profit_color}}
																		         className={"stock-arrow"}/> :
																		<MDBIcon icon="caret-down"
																		         style={{color: loss_color}}
																		         className={"stock-arrow"}/>
																}
															</MDBBox>
														</MDBBox>
														<MDBBox className="w-50">
															<p className="stock-value-in-text">1Y High</p>
															<MDBBox className="d-flex align-items-center">
																<p className="stock-value-in-number-red "
																	// style={{color: this.state.stock_data.stockHighValueLongTerm > 0 ? profit_color : loss_color}}
																>
																	₹{this.state.stockHistoryDetails.long_term_high_value !== null ? this.state.stockHistoryDetails.long_term_high_value : 0}
																</p>
																{
																	this.state.stockHistoryDetails.long_term_high_value >= 0 ?
																		<MDBIcon icon="caret-up"
																		         style={{color: profit_color}}
																		         className={"stock-arrow"}/> :
																		<MDBIcon icon="caret-down"
																		         style={{color: loss_color}}
																		         className={"stock-arrow"}/>
																}
															</MDBBox>
														</MDBBox>

													</div>
													{/*</Fade>*/}
												</MDBBox>
											</MDBBox>
									}
								</div>
								 {/*}*/}
								{/*</Fade>*/}

								{this.state.stock_detail.upcoming === false && this.state.stock_detail.buySellHold &&
								<MDBBox className="analyst-rating-section">
									<div className={"d-flex align-items-center"}>
										<MDBTypography className="title" tag={"p"}>Analyst Rating</MDBTypography>
										<img alt={"alt"} src={dot_icon} className="dot_icon" data-tip
										     data-for={'analyst-info'}/>
										{/*<ReactTooltip id='analyst-info' type='light' effect={"solid"} place={"bottom"}*/}
										{/*              style={{background: "rgba(255, 255, 255, 0.28)"}}>*/}
										{/*	<span className={"tooltip-analyst"}>Lorem ipsum dummy text is the <br/>industry standard of design</span>*/}
										{/*</ReactTooltip>*/}
									</div>
									<ThreeDPieChart chart_data={this.state.analyst_rating}/>
								</MDBBox>
								}
							</>
						}
					</>

					{/* news section*/}
					{this.state.news_list.length > 0 && <div>
						<SectionHeader heading={"News"} image={NewsIcon} viewmore={true}
						               redirect={"/extend/news"}/>
						<div className={"news-section"}>
							<NewsList news_list={this.state.news_list}/>
						</div>
					</div>}

					{/*{this.state.key_info.length > 0 &&*/}
					<div className={"key-info-section"}>
						<KeyInfo key_info={this.state.key_info} componentLoading={Object.keys(this.state.stock_detail).length<1}/>
					</div>
					{/*}*/}

					{Object.keys(this.state.politician_assets).length > 0 &&
					<div className="asset-section">
						<SectionHeader heading={"Assets"} image={AssetIcon} viewmore={false}/>
						<MDBBox className="asset_container">
							<MDBBox className="asset-card-header d-flex justify-content-between align-items-center">
								<p className="asset-card-header-title ">Total Assets</p>
								<p className="asset-total  text-right">
									{this.state.politician_assets.totalAssets ? numberFormat(this.state.politician_assets.totalAssets) : 0}
								</p>
							</MDBBox>
							{
								this.state.politician_assets.immovableAssets > 0 && this.state.politician_assets.movableAssets > 0 && this.state.politician_assets.investments > 0 &&

								// <Fade bottom cascade>
								<div className={"asset-container-body"}>
									{
										this.state.politician_assets.immovableAssets > 0 &&
										<MDBBox className="d-flex justify-content-between">
											<p className="asset-key ">Immovable Assests</p>
											<p className="asset_value  text-right">
												{this.state.politician_assets.immovableAssets ? numberFormat(this.state.politician_assets.immovableAssets) : 0}
											</p>
										</MDBBox>
									}
									{
										this.state.politician_assets.movableAssets > 0 &&
										<MDBBox className="d-flex justify-content-between "
										        style={{padding: "24px 0"}}>
											<p className="asset-key">Movable Assests</p>
											<p className="asset_value text-righte">
												{this.state.politician_assets.movableAssets ? numberFormat(this.state.politician_assets.movableAssets) : 0}
											</p>
										</MDBBox>
									}
									{
										this.state.politician_assets.investments > 0 &&
										<MDBBox className="d-flex justify-content-between ">
											<p className="asset-key ">Investments</p>
											<p className="asset_value_active  text-right">
												{this.state.politician_assets.investments ? numberFormat(this.state.politician_assets.investments) : 0}
											</p>
										</MDBBox>
									}

								</div>
								// </Fade>
							}
						</MDBBox>
					</div>}

					{/* political career */}
					{this.state.political_career.length > 0 &&
					<div className={" section-top"}>
						<SectionHeader heading={"Political Career"} image={ZigZagIcon} viewmore={false}/>
						<div className={"political-career-section"}>
							{
								this.state.political_career.map((item, index) => {
									return (
										//fade bottom
										<div key={index} style={{marginBottom: "16px"}}>
											<div className="d-flex align-items-center political-career-card">
												<div className="political_dot"/>
												<div className="political_year "><p
													className={"mb-0 animate__animated animate__fadeInRight"}>{item.node.year}</p>
												</div>
												<div>
													<div className="political_government">
														<div className="political_gov">
															<p className="political_central">{item.node.govt}</p>
															<p className="political_current">{item.node.workedAs}</p>
														</div>
													</div>
												</div>

											</div>
										</div>
									);
								})
							}
							{
								this.state.political_career.length === 0 &&
								<div className={"error-section"}>No Datas Found</div>
							}
						</div>
					</div>}
					{/*similar stock*/}
					{this.state.similarStocks.length > 0 &&
					<div>
						{/*<Fade bottom>*/}
						<div
							className={"section-header-component d-flex align-items-center justify-content-between"}>
							<div className={"d-flex align-items-center justify-content-between"}>
								<img src={SimilarTocksIcon} alt={'alt'} className={"img-fluid"}/>
								<p className={"section-title"}>Similar Politicians</p>
							</div>
							<div className={"d-flex align-items-center"} onClick={this.filterStock}>
								<p className={"view-all-text"}>View All</p>
								<img src={AngleRight} alt={"AngleRight"}/>
							</div>
						</div>
						{/*</Fade>*/}
						{/*<Slide right delay={500}>*/}
						<div className={"similar-stock-section"}>
							<SimilarStocks stock_list={this.state.similarStocks}
							               stock_history_details={this.state.stockHistoryDetails}
							               setStockId={(args) => this.handleSimilareStockRedirection(args)}/>
						</div>
						{/*</Slide>*/}
					</div>}

					<BottomModal
						title={modal_title}
						isOpen={this.state.open_modal
							// && this.state.selected_action !== "add_money"
						}
						closeModal={this.closeModal}
						removeHeader={this.state.selected_action === "" || this.state.selected_action === "waiting"}
						hideBorder={this.state.selected_action === "add_money"}
						setBackground={this.state.selected_action !== "add_money" && this.state.selected_action !== "buy" && this.state.selected_action !== "sell"}
						footer={this.state.selected_action !== ""}
						footerComponent={"add_money" !== this.state.selected_action && "waiting" !== this.state.selected_action &&
						<DetailPageModalFooter
							limit_order_price={this.state.limit_order_price}
							stock_data={this.state.stock_detail}
							order_mode={this.state.orderMode}
							submit={this.handleSellOrBuySubmit}
							buttonText={this.state.stock_detail.upcoming === true ? "Subscribe" : "Enter PIN"}
							quantity={this.state.quantity}
							walletData={this.props.wallet_data}
							selected_action={this.state.selected_action}
						/>
						}
					>
						{
							<div>
								{
									this.state.selected_action !== "" ?
										<>
											{
												this.state.selected_action === "add_money" ?
													<AddMoney
														setActiveModal={(args) => this.setState({selected_action: args})}
														hideDefaultClose={true}
														user_details={this.props.user_details}
													/> :
													this.state.selected_action === "waiting" ?
														<OrderPendingModal order_mode={this.state.orderMode}
														                   checkStatus={this.checkStatus}
														                   closeModal={this.closeModal}
														                   order_status={this.state.lastOrderStatus}
														/>
														:
														this.state.stock_detail.upcoming === true ?
															<PreBookStock
																selected_stock={this.state.stock_detail}
																submit={this.handleSellOrBuySubmit}
																handleRadioInputs={this.handleRadioInputs}
																order_mode={this.state.orderMode}
																handleQtyChange={this.handleQtyChange}
																quantity={this.state.quantity}
															/> :
															<BuyOrSellStock
																selected_action={this.state.selected_action}
																submit={this.handleSellOrBuySubmit}
																handleRadioInputs={this.handleRadioInputs}
																order_mode={this.state.orderMode}
																handleQtyChange={this.handleQtyChange}
																quantity={this.state.quantity}
																stock_data={this.state.stock_detail}
																stock_history_details={this.state.stockHistoryDetails}
																stockOwnedCount={this.state.stockOwnedCount}
																wallet_data={this.props.wallet_data}
																limit_order_price={this.state.limit_order_price}
																setState={(args) => this.setState(args)}
															/>

											}
										</>
										:
										<OrderConfirmation
											closeModal={this.closeModal}
											wallet_data={this.props.wallet_data}
											quantity={this.state.quantity}
											completed_action={this.state.completed_action}
											order_failed={this.state.order_failed}
											stock_data={this.state.stock_detail}
											submit={this.createOrder}
											limit_order_price={this.state.limit_order_price}
											order_mode={this.state.orderMode}
											addMoney={(args) => this.setState({selected_action: args})}
										/>

								}
							</div>

						}
					</BottomModal>
					{/*<PinVerificationModal*/}
					{/*    isOpen={this.state.full_height_modal}*/}
					{/*    closeModal={this.closeFullHeightModal}>*/}
					{/*    {*/}
					<PinVerification
						submit={this.createOrder}
						handlePinInputChange={this.handlePinInputChange}
						pin={this.state.pin}
						selected_action={this.state.selected_action}
						stock_data={this.state.stock_detail}
						quantity={this.state.quantity}
						order_mode={this.state.orderMode}
						limit_order_price={this.state.limit_order_price}
						isOpen={this.state.full_height_modal}
						closeModal={this.closeFullHeightModal}
					/>
					{/*    }*/}
					{/*</PinVerificationModal>*/}

				</div>
				<div className={"bottom-space"}/>

				{/*<div className="">*/}
				<div className=" action-btn-section d-flex justify-content-between ">
					{
						this.state.stock_detail.upcoming === true ?
							<button disabled={Object.keys(this.state.stock_detail).length < 1} className="button-class "
									onClick={()=>this.checkUserLoggedIn("buy")}>
								Subscribe
							</button>
							:
							<>
								<button disabled={Object.keys(this.state.stock_detail).length < 1}
								        className="button-class" onClick={()=>this.checkUserLoggedIn("buy")}>
									<img alt={"alt"} src={button_arrow_down} className="button_icon mr-2"/>
									Buy Now
								</button>
								<div className={"button-gap"}/>
								<button disabled={Object.keys(this.state.stock_detail).length < 1}
								        className="button-class_up"  onClick={()=>this.checkUserLoggedIn("sell")}
								>
									<img alt={"alt"} src={button_arrow_up} className="button_icon mr-2"/>
									Sell Now
								</button>
							</>
					}
				</div>
				{/*</div>*/}
				<Login isOpen={this.state.login_modal}
					   closeModal={this.closeLoginModal}
					   completeLogin={this.completeLogin}
				/>
			</MDBBox>
			// {/*}*/}
			// </Loading>
		);
	}
}

const mapStateToProps = state => ({
	wallet_data: state.WalletReducer.wallet_data,
	logged_in: state.UserReducer.logged_in

});

const mapDispatchToProps = dispatch => ({
	applyFilter: data => dispatch(AddFilter(data)),
});

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps)
)(StockDetail)

function BuyOrSellStock(props) {
	const {
		selected_action,
		order_mode,
		handleRadioInputs,
		quantity,
		handleQtyChange,
		submit,
		stock_data,
		wallet_data,
		limit_order_price,
		setState,
		stockOwnedCount,
		stock_history_details
	} = props;

	const totalWalletBalance = () => {
		let deposit = parseInt(wallet_data.availableDeposit);
		let earnings = parseInt(wallet_data.availableEarnings);
		let grant = parseInt(wallet_data.availableGrantMoney);
		return (deposit + earnings + grant).toFixed(2);
	}
	return (
		<div className={"buy-and-sell-component"}>
			<div className="d-flex align-items-start justify-content-between">
				<div className={"d-flex align-items-center"}>
					<div className="stock-profile-section" style={{overflow: "hidden"}}>
						<img src={stock_data.politicianImage ? stock_data.politicianImage : ProfileIcon} alt="userImage"
						     className="img-fluid" style={{width: "64px", height: "64px", objectFit: "contain"}}/>
					</div>
					<div className={"stock-detail-section"}>
						<p className={"stock-name"}>{stock_data.name}</p>
						{/*stockOwnedCount change*/}
						{stockOwnedCount > 0 &&
						<div className={"d-flex align-items-center stock-own-section"}>
							<img src={GraphIcon} alt={"GraphIcon"}/>
							<div className={"d-flex align-items-center"}>
								<p className="stock-count">{stockOwnedCount}</p>
								<p className={"stock-own-content"}>Shares owned</p>
							</div>
						</div>}

					</div>
				</div>
				<div>
					<p className="stock-price">₹ {stock_data.price}</p>
					<div className="d-flex align-items-center justify-content-end">
						<img
							src={stock_history_details.price_diff_percentage >= 0 ? vector_arrow_up : vector_arrow_down}
							alt={"vector_arrow_up"} className="img-fluid" width={"10px"}/>
						{
							stock_history_details.price_diff_percentage >= 0 ?
								<p className="mb-0 stock-percentage"
								   style={{color: profit_color}}>
									{stock_history_details.price_diff_percentage}%
									{/*({numberFormat(stock_data.priceDiffPercentage.toFixed(2))})*/}
								</p> :
								<p className="mb-0 stock-percentage" style={{color: loss_color}}>
									{stock_history_details.price_diff_percentage}%
									{/*({numberFormat(stock_data.priceDiffPercentage.toFixed(2))})*/}
								</p>

						}
						{/*<img src={vector_arrow_up} alt={"vector_arrow_up"} className="img-fluid" width={"10px"}/>*/}
						{/*<p className={"mb-0 stock-percentage"}>{stock_data.priceDiffPercentage}%</p>*/}
					</div>
				</div>
			</div>
			{
				selected_action === "buy" &&
				<>
					<div className={"wallet-card d-flex align-items-center justify-content-between"}>
						<div className={"d-flex "}>
							<div className={"wallet-image d-flex align-items-center justify-content-center"}>
								<img src={WalletIcon} alt={"WalletIcon"} className={"img-fluid"}/>
							</div>
							<div className={"wallet-description"}>
								<p className={"wallet-amount-content"}>Wallet Amount</p>
								<p className={"wallet-amount mb-0"}>
									₹ {
									Object.keys(wallet_data).length > 0 ?
										wallet_data.balance : 0
								}
								</p>
							</div>

						</div>
						{/*<Link to={"/wallet"}>*/}
						<button className={"btn add-money-btn"}
						        onClick={() => setState({selected_action: "add_money"})}>
							Add Money
							<img src={ArrowRightIcon} alt={ArrowRightIcon} style={{marginLeft: "4px"}}/>
						</button>
						{/*</Link>*/}
					</div>

				</>
			}
			<p className={"share-content"}>{selected_action === "sell" ? "Sell" : "Buy"} Shares at: </p>
			<div className="custom-radio-input-section" style={{borderBottom: "1px solid #EAEAEA"}}>
				<ul>
					<li>

						<input type="radio" id="f-option" name="selector"
						       checked={order_mode === "Market_Order"}
						       onChange={() => handleRadioInputs("Market_Order")}
						/>
						<label htmlFor="f-option">Current Market Price</label>
						<div className="check"/>

					</li>
					<li>
						<input type="radio" id="s-option" name="selector"
						       checked={order_mode === "Limit_Order"}
						       onChange={() => handleRadioInputs("Limit_Order")}
						/>
						<label htmlFor="s-option">Your Defined Target Price</label>
						<div className="check">
							<div className="inside"/>
						</div>
					</li>
				</ul>
			</div>
			<div className={"text-center order-form-section"}>
				{
					order_mode === "Market_Order" &&
					<div>
						<p className={"price-per-share "} style={{marginBottom: "16px"}}>Price per Share</p>
						<p className={"price-per-share-amount mb-0"}>₹ {stock_data.price}</p>
					</div>
				}
				{
					order_mode === "Limit_Order" &&
					<div>
						<p className={"price-per-share"} style={{marginBottom: "12px"}}>Set Price per Share</p>
						<form>
							<input type="number"
							       className="form-control quantity-input"
							       value={limit_order_price}
							       onChange={(e) => handleQtyChange(e, "limit_order_price")}
							/>
						</form>
					</div>
				}

				<p className={"price-per-share"} style={{marginTop: "24px", marginBottom: "12px"}}>SET share
					QUANTITY</p>
				<form>
					<input type="number"
					       step={".01"}
					       className="form-control quantity-input"
					       value={quantity}
						// inputMode="decimal"
						   onKeyDown={(e) => {
							   if (e.key === 'Enter') {
								   e.preventDefault()
								   submit(e)
							   }
						   }}
						   onChange={(e) => handleQtyChange(e, "quantity")}
					/>
				</form>
				<br/>
				<p className={"share-description"}>
					You can {selected_action === "buy" ? "buy" : "sell"} whole or fractional shares.
					Share quantity capped at 20.
				</p>

			</div>
			{/*<br/>*/}

		</div>
	)
}



